import { CheckboxFilterGroup } from '@retail/components';
import { useProductsTFunction } from '@retail/products/i18n';
import { useMemo } from 'react';

interface Props {
  climateDataA1ToA3Included: boolean;
  toggleClimateDataA1ToA3Included: () => void;
}

const A1_TO_A3 = 'A1TOA3';

export function ClimateDataValueFilter({
  climateDataA1ToA3Included,
  toggleClimateDataA1ToA3Included,
}: Props) {
  const t = useProductsTFunction();

  const options = useMemo(
    () => [{ label: t('products.mgItem.gwp.A1ToA3'), value: A1_TO_A3 }],
    [t]
  );

  return (
    <CheckboxFilterGroup
      label={t('products.mgItem.climateData')}
      options={options}
      selected={climateDataA1ToA3Included ? [A1_TO_A3] : []}
      onToggle={toggleClimateDataA1ToA3Included}
    />
  );
}
